import { useState } from "react";
import config from "../config";

export default function RegisterPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [alert, setAlert] = useState({ message: "", type: "" }); // State for alerts

  // Function to validate password strength
  const isPasswordStrong = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    return (
      password.length >= minLength &&
      hasUpperCase &&
      hasLowerCase &&
      hasNumbers &&
      hasSpecialChars
    );
  };

  async function register(ev) {
    ev.preventDefault();

    // Check username and password validity
    if (username.length < 6) {
      setAlert({
        message: "Username must be at least 6 characters long.",
        type: "error",
      });
      return;
    }
    if (!isPasswordStrong(password)) {
      setAlert({
        message:
          "Password must be at least 8 characters long and include uppercase letters, lowercase letters, numbers, and special characters.",
        type: "error",
      });
      return;
    }

    setAlert({ message: "", type: "" }); // Clear previous alerts

    const response = await fetch(`${config.apiUrl}/register`, {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: { "Content-Type": "application/json" },
    });

    if (response.status === 200) {
      setAlert({ message: "Registration successful!", type: "success" });
      // Optionally reset the form
      setUsername("");
      setPassword("");
    } else {
      setAlert({
        message: "Registration failed. Please try again.",
        type: "error",
      });
    }
  }

  return (
    <div className="validation-box register-colors">
      <div className="auth">
        <form onSubmit={register}>
          <h1>Register</h1>
          <input
            type="text"
            placeholder="username"
            value={username}
            onChange={(ev) => setUsername(ev.target.value)}
          />
          <input
            type="password"
            placeholder="password"
            value={password}
            onChange={(ev) => setPassword(ev.target.value)}
          />
          <button className="forms-button">
            <span>Register</span>
          </button>
          <ul className="password-rules">
            <li>
              At least <strong>8 characters</strong> long
            </li>
            <li>
              Includes <strong>uppercase letters</strong> [A-Z]
            </li>
            <li>
              Includes <strong>lowercase letters</strong> [a-z]
            </li>
            <li>
              Includes <strong>numbers</strong> [0-9]
            </li>
            <li>
              Includes <strong>special characters</strong> [!@#$%^&*(),.?":{}]
            </li>
          </ul>{" "}
        </form>
      </div>
      {alert.message && (
        <div className={`alert ${alert.type}`}>{alert.message}</div>
      )}
    </div>
  );
}
